import { render, staticRenderFns } from "./questionnaireResult.vue?vue&type=template&id=f5f3ec5c&scoped=true&"
import script from "./questionnaireResult.vue?vue&type=script&lang=js&"
export * from "./questionnaireResult.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireResult.vue?vue&type=style&index=0&id=f5f3ec5c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f3ec5c",
  null
  
)

component.options.__file = "questionnaireResult.vue"
export default component.exports